/**
 * 用户端 / 管理端门户（与 server/common/utils/authPortal.js 中 portalForRole 一致）
 * 优先：会话 loginPortal → 角色推断 → 当前路径以 /management 开头 → 构建变量 REACT_APP_AUTH_PORTAL
 */

import { IPE_LOGIN_PATH, isIpeLoginPath } from '@/config/ipeRoutes';

export const PORTAL_USER = 'user';
export const PORTAL_MANAGEMENT = 'management';

const SESSION_KEY = 'react-basic-session';

const USER_PORTAL_ROLES = new Set(['普通', '主体', '主体助手']);

export function roleToPortal(role) {
  const r = role != null ? String(role).trim() : '';
  if (!r || USER_PORTAL_ROLES.has(r)) return PORTAL_USER;
  if (r === '管理员' || r === '管理') return PORTAL_MANAGEMENT;
  if (r === '管理助手' || r.startsWith('管理助手')) return PORTAL_MANAGEMENT;
  return PORTAL_USER;
}

/**
 * 登录等请求体中的 appPortal。
 * 显式登录页路径优先于 localStorage，避免旧会话干扰「当前正在哪一端登录」。
 */
export function getAuthAppPortal() {
  if (typeof window !== 'undefined') {
    const p = window.location.pathname || '';
    if (p === '/management' || p.startsWith('/management/')) return PORTAL_MANAGEMENT;
    if (isIpeLoginPath(p) || p === '/register') return PORTAL_USER;
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      if (raw) {
        const j = JSON.parse(raw);
        if (j.loginPortal === PORTAL_MANAGEMENT || j.loginPortal === PORTAL_USER) {
          return j.loginPortal;
        }
        if (j.role) return roleToPortal(j.role);
      }
    } catch (_) {
      /* ignore */
    }
  }
  const v = String(
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_AUTH_PORTAL) || ''
  )
    .trim()
    .toLowerCase();
  if (v === 'management') return PORTAL_MANAGEMENT;
  return PORTAL_USER;
}

/**
 * 当前仓库为 IPE 工具壳：无独立登录路由时，认证失效 / 退出后回到工作台。
 * 可通过 REACT_APP_AUTH_LANDING_PATH=/your-path 覆盖（须以 / 开头）。
 */
export function getAuthLandingPath() {
  const raw =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_AUTH_LANDING_PATH != null
      ? String(process.env.REACT_APP_AUTH_LANDING_PATH).trim()
      : '';
  if (raw.startsWith('/')) return raw;
  return IPE_LOGIN_PATH;
}

/** 退出/失效后跳转登录页的 path（优先会话，其次当前路径） */
export function getLoginPath() {
  if (typeof window !== 'undefined') {
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      if (raw) {
        const j = JSON.parse(raw);
        if (j.loginPortal === PORTAL_MANAGEMENT || j.loginPortal === PORTAL_USER) {
          return j.loginPortal === PORTAL_MANAGEMENT ? '/management/login' : IPE_LOGIN_PATH;
        }
        if (j.role) {
          return roleToPortal(j.role) === PORTAL_MANAGEMENT ? '/management/login' : IPE_LOGIN_PATH;
        }
      }
    } catch (_) {
      /* ignore */
    }
    const p = window.location.pathname || '';
    if (p === '/management' || p.startsWith('/management/')) return '/management/login';
  }
  return IPE_LOGIN_PATH;
}

export function isManagementPathname(pathname) {
  const p = pathname != null ? String(pathname) : '';
  return p === '/management' || p.startsWith('/management/');
}
